import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnDestroy } from '@angular/core';
import type { MainSmsAccountFindInterface } from '@zaoblako/shared/modules/integration/dtos/main-sms/main-sms-account-find.dto';
import { MainSmsIntegrationTypeEnum } from '@zaoblako/shared/modules/integration/enums/main.sms.integration.type.enum';
import { NewsletterSmsAddComponent } from '@zaoblako/web/modules/debts/components/newsletter/settings/components/sms-add/newsletter-sms-add.component';
import { ButtonComponent } from '@zaoblako/web/shared/dumbs/button/button.component';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'crm-newsletter-mailing-limit-modal',
  standalone: true,
  imports: [CommonModule, ButtonComponent],
  templateUrl: './newsletter-mailing-limit-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NewsletterMailingLimitModalComponent implements OnDestroy {
  public type: MainSmsIntegrationTypeEnum;
  private addRef: DynamicDialogRef;

  public constructor(
    private readonly ref: DynamicDialogRef,
    private readonly config: DynamicDialogConfig,
    private readonly dialogService: DialogService
  ) {
    if (config.data.type) {
      this.type = config.data.type;
    }
  }

  public ngOnDestroy() {
    this.addRef?.close();
  }

  public linkToRegister() {
    window.open('https://mainsms.ru/users/sign_up', '_blank');
  }

  public showAddModal() {
    this.addRef = this.dialogService.open(NewsletterSmsAddComponent, {
      header: 'Новая интеграция с MainSMS',
      contentStyle: { overflow: 'auto' },
      styleClass: 'xl:w-5 lg:w-6 md:w-8 sm:w-11 w-full',
      focusOnShow: false,
      baseZIndex: 10000,
      data: {
        type: this.type
      }
    });

    this.addRef.onClose.subscribe((sms: MainSmsAccountFindInterface) => {
      if (sms) {
        this.ref?.close(sms);
      }
    });
  }

  public closeModal() {
    this.ref?.close();
  }
}
